<pui-page-header [title]="'Wydarzenia'">
  <pui-breadcrumbs>
    <a pui-breadcrumbs-item href="/">
      <pui-icon icon="home-line" />
    </a>
    <a pui-breadcrumbs-item href="/">Wydarzenia</a>
  </pui-breadcrumbs>
  <button pui-button variant="primary" (click)="onAdd()">Nowe wydarzenie<pui-icon icon="plus" left />
  </button>
</pui-page-header>

<div class="page-container">
  <pui-table2 [dataSource]="filteredEvents()" [trackBy]="trackBy" [sortBy]="sort().key"
    [sortDirection]="sort().direction" (sortChange)="onSortChange($event)">
    <ng-container header>
      <form class="d-flex align-items-center w-100 gap-16" [formGroup]="filtersForm">
        <pui-form-field>
          <pui-label>Wyszukaj</pui-label>
          <pui-icon icon="search-md" left />
          <input puiInput placeholder="Wyszukaj" formControlName="global" />
        </pui-form-field>
        <pui-divider />
        <pui-form-field>
          <pui-label>Typ</pui-label>
          <pui-select [multiple]="false" formControlName="eventType">
            <pui-placeholder>Typ</pui-placeholder>
            @for (option of eventTypeOptions; track $index) {
            <pui-option [value]="option">{{ option }}</pui-option>
            }
          </pui-select>
        </pui-form-field>
        <pui-form-field>
          <pui-label>Powtarzalne</pui-label>
          <pui-select [multiple]="false" formControlName="repeatable">
            <pui-placeholder>Powtarzalne</pui-placeholder>
            <pui-option [value]="'Wszystkie'">Wszystkie</pui-option>
            <pui-option [value]="'true'">Tak</pui-option>
            <pui-option [value]="'false'">Nie</pui-option>
          </pui-select>
        </pui-form-field>
      </form>
    </ng-container>
    <ng-template #header>
      <th>Rok</th>
      <th>Data</th>
      <th>Powtarzalne</th>
      <th>Typ</th>
      <th pui-column-header key="reason">Powód</th>
      <th>Akcje</th>
    </ng-template>
    <ng-template #row let-row>
      <tr [class.row-disabled]="row.date < today">

        <td>{{ row.date | date: 'yyyy' }}</td>
        <td>{{ row.date | date: 'MM-dd' }}</td>
        <td>{{ $safeNavigationMigration(row?.repeatable) | yesNo }}</td>
        <td>{{ row?.eventType }}</td>
        <td>{{ row?.reason }}</td>
        <td>
          <button pui-button variant="tertiary" (click)="onEdit(row)"><pui-icon class="action-icon" left
              icon="edit-03" /></button>
          <button pui-button variant="tertiary" (click)="onDelete(row.id)"><pui-icon left icon="trash-03"
              class="remove-icon" /></button>
        </td>
      </tr>
    </ng-template>
  </pui-table2>
</div>